
export const chartData = {
    graphData: [
        {
        name: '1', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '2', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '3', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '4', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '5', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '6', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '7', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '8', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '9', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '10', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '11', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '12', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '13', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '14', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '15', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '16', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '17', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '18', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '19', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '20', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '21', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '22', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '23', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '24', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '25', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '26', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '27', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        },
        {
        name: '28', visits: Math.floor(Math.random() * (5000 - 3500)) + 3500,
        }
    ],
    MVPage: [
        {
            path: "/store/",
            visitors: 4890,
            uniqueVisitors: 3985,
            bounceRate: 81.56,
            data:""
        },
        {
            path: "/store/symbols-styleguids",
            visitors: 3785,
            uniqueVisitors: 3185,
            bounceRate: 62.56,
            data: ""
        },
        {
            path: "/store/dashboard-ui-kit",
            visitors: 2985,
            uniqueVisitors: 2115,
            bounceRate: 58.76,
            data: ""
        },
        {
            path: "/store/webflow-cards.html",
            visitors: 2440,
            uniqueVisitors: 1789,
            bounceRate: 39.59,
            data: ""
        }
    ],
    SMTraffic: [
        {
            network: "Instagram",
            visitors: 3550,
            progress: 70
        },
        {
            network: "Facebook",
            visitors: 2230,
            progress: 50
        },
        {
            network: "Twitter",
            visitors: 1576,
            progress: 35
        },
        {
            network: "Linkedin",
            visitors: 765,
            progress: 15
        }
    ]
};
